var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.value,"id":_vm.id,"hide-details":"","label":_vm.etiket,"name":_vm.name},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }